import React from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';

export interface StepDescriptionProps {
  stepText?: string;
  title: string;
  description?: string;
  className?: string;
}

function StepDescription(props: StepDescriptionProps) {
  return (
    <div className={clsx(styles.root, props.className)}>
      {props.stepText && <h3>{props.stepText}</h3>}
      <h2>{props.title}</h2>
      <p>{props.description}</p>
    </div>
  );
}

export default StepDescription;
